/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminCreateProductOrder,
    AdminCreateProductOrderFromJSON,
    AdminCreateProductOrderToJSON,
    AdminOrderStatus,
    AdminOrderStatusFromJSON,
    AdminOrderStatusToJSON,
    AdminProductOrdersResp,
    AdminProductOrdersRespFromJSON,
    AdminProductOrdersRespToJSON,
} from '../models';

import {
    AdminOrdersApi,
    AdminOrdersApiAdminCreateProductOrderRequest,
    AdminOrdersApiAdminGetOrdersByProductIDRequest,
    AdminOrdersApiAdminUpdateOrderStatusRequest,
} from './AdminOrdersApi';

type AdminCreateProductOrderQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['adminCreateProductOrder', AdminOrdersApiAdminCreateProductOrderRequest]
>;

let useAdminCreateProductOrderQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminOrdersApiAdminCreateProductOrderRequest,
          options?: AdminCreateProductOrderQueryOptions
      ) => AdminCreateProductOrderQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminCreateProductOrderQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminOrdersApiAdminCreateProductOrderRequest,
        options?: AdminCreateProductOrderQueryOptions
    ) => AdminCreateProductOrderQueryOptions | undefined
) {
    useAdminCreateProductOrderQueryGlobalOptions = callback;
}

export function getAdminCreateProductOrderQueryKey(
    params: AdminOrdersApiAdminCreateProductOrderRequest
): ['adminCreateProductOrder', AdminOrdersApiAdminCreateProductOrderRequest] {
    return ['adminCreateProductOrder', params];
}

export function useAdminCreateProductOrderQuery(
    params: AdminOrdersApiAdminCreateProductOrderRequest,
    options?: AdminCreateProductOrderQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminCreateProductOrderQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminOrdersApi().adminCreateProductOrder(params, {signal})
            ),
        {
            ...options,
            ...useAdminCreateProductOrderQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminCreateProductOrderMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    AdminOrdersApiAdminCreateProductOrderRequest
>;

let useAdminCreateProductOrderMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminCreateProductOrderMutationOptions
      ) => AdminCreateProductOrderMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminCreateProductOrderMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminCreateProductOrderMutationOptions
    ) => AdminCreateProductOrderMutationOptions | undefined
) {
    useAdminCreateProductOrderMutationGlobalOptions = callback;
}

export function useAdminCreateProductOrderMutation(
    options?: AdminCreateProductOrderMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, AdminOrdersApiAdminCreateProductOrderRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminOrdersApi().adminCreateProductOrder(params)),
        {
            ...options,
            ...useAdminCreateProductOrderMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminCreateProductOrderInfiniteQueryKey(
    params: AdminOrdersApiAdminCreateProductOrderRequest
): ['adminCreateProductOrder-infinite', AdminOrdersApiAdminCreateProductOrderRequest] {
    return ['adminCreateProductOrder-infinite', params];
}

export function useAdminCreateProductOrderInfiniteQuery(
    params: AdminOrdersApiAdminCreateProductOrderRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['adminCreateProductOrder-infinite', AdminOrdersApiAdminCreateProductOrderRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminCreateProductOrderInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminOrdersApi().adminCreateProductOrder({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminGetOrdersByProductIDQueryOptions = UseQueryOptions<
    AdminProductOrdersResp,
    Array<Error>,
    AdminProductOrdersResp,
    ['adminGetOrdersByProductID', AdminOrdersApiAdminGetOrdersByProductIDRequest]
>;

let useAdminGetOrdersByProductIDQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminOrdersApiAdminGetOrdersByProductIDRequest,
          options?: AdminGetOrdersByProductIDQueryOptions
      ) => AdminGetOrdersByProductIDQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGetOrdersByProductIDQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminOrdersApiAdminGetOrdersByProductIDRequest,
        options?: AdminGetOrdersByProductIDQueryOptions
    ) => AdminGetOrdersByProductIDQueryOptions | undefined
) {
    useAdminGetOrdersByProductIDQueryGlobalOptions = callback;
}

export function getAdminGetOrdersByProductIDQueryKey(
    params: AdminOrdersApiAdminGetOrdersByProductIDRequest
): ['adminGetOrdersByProductID', AdminOrdersApiAdminGetOrdersByProductIDRequest] {
    return ['adminGetOrdersByProductID', params];
}

export function useAdminGetOrdersByProductIDQuery(
    params: AdminOrdersApiAdminGetOrdersByProductIDRequest,
    options?: AdminGetOrdersByProductIDQueryOptions
): UseQueryResult<AdminProductOrdersResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminGetOrdersByProductIDQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminOrdersApi().adminGetOrdersByProductID(params, {signal})
            ),
        {
            ...options,
            ...useAdminGetOrdersByProductIDQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminGetOrdersByProductIDMutationOptions = UseMutationOptions<
    AdminProductOrdersResp,
    Array<Error>,
    AdminOrdersApiAdminGetOrdersByProductIDRequest
>;

let useAdminGetOrdersByProductIDMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminGetOrdersByProductIDMutationOptions
      ) => AdminGetOrdersByProductIDMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGetOrdersByProductIDMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminGetOrdersByProductIDMutationOptions
    ) => AdminGetOrdersByProductIDMutationOptions | undefined
) {
    useAdminGetOrdersByProductIDMutationGlobalOptions = callback;
}

export function useAdminGetOrdersByProductIDMutation(
    options?: AdminGetOrdersByProductIDMutationOptions
): UseMutationResult<AdminProductOrdersResp, Array<runtime.ApiError>, AdminOrdersApiAdminGetOrdersByProductIDRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminOrdersApi().adminGetOrdersByProductID(params)),
        {
            ...options,
            ...useAdminGetOrdersByProductIDMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminGetOrdersByProductIDInfiniteQueryKey(
    params: AdminOrdersApiAdminGetOrdersByProductIDRequest
): ['adminGetOrdersByProductID-infinite', AdminOrdersApiAdminGetOrdersByProductIDRequest] {
    return ['adminGetOrdersByProductID-infinite', params];
}

export function useAdminGetOrdersByProductIDInfiniteQuery(
    params: AdminOrdersApiAdminGetOrdersByProductIDRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminProductOrdersResp,
            Array<runtime.ApiError>,
            AdminProductOrdersResp,
            AdminProductOrdersResp,
            ['adminGetOrdersByProductID-infinite', AdminOrdersApiAdminGetOrdersByProductIDRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminProductOrdersResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminGetOrdersByProductIDInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminOrdersApi().adminGetOrdersByProductID({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminUpdateOrderStatusQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['adminUpdateOrderStatus', AdminOrdersApiAdminUpdateOrderStatusRequest]
>;

let useAdminUpdateOrderStatusQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminOrdersApiAdminUpdateOrderStatusRequest,
          options?: AdminUpdateOrderStatusQueryOptions
      ) => AdminUpdateOrderStatusQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminUpdateOrderStatusQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminOrdersApiAdminUpdateOrderStatusRequest,
        options?: AdminUpdateOrderStatusQueryOptions
    ) => AdminUpdateOrderStatusQueryOptions | undefined
) {
    useAdminUpdateOrderStatusQueryGlobalOptions = callback;
}

export function getAdminUpdateOrderStatusQueryKey(
    params: AdminOrdersApiAdminUpdateOrderStatusRequest
): ['adminUpdateOrderStatus', AdminOrdersApiAdminUpdateOrderStatusRequest] {
    return ['adminUpdateOrderStatus', params];
}

export function useAdminUpdateOrderStatusQuery(
    params: AdminOrdersApiAdminUpdateOrderStatusRequest,
    options?: AdminUpdateOrderStatusQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminUpdateOrderStatusQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminOrdersApi().adminUpdateOrderStatus(params, {signal})
            ),
        {
            ...options,
            ...useAdminUpdateOrderStatusQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminUpdateOrderStatusMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    AdminOrdersApiAdminUpdateOrderStatusRequest
>;

let useAdminUpdateOrderStatusMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminUpdateOrderStatusMutationOptions
      ) => AdminUpdateOrderStatusMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminUpdateOrderStatusMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminUpdateOrderStatusMutationOptions
    ) => AdminUpdateOrderStatusMutationOptions | undefined
) {
    useAdminUpdateOrderStatusMutationGlobalOptions = callback;
}

export function useAdminUpdateOrderStatusMutation(
    options?: AdminUpdateOrderStatusMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, AdminOrdersApiAdminUpdateOrderStatusRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminOrdersApi().adminUpdateOrderStatus(params)),
        {
            ...options,
            ...useAdminUpdateOrderStatusMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminUpdateOrderStatusInfiniteQueryKey(
    params: AdminOrdersApiAdminUpdateOrderStatusRequest
): ['adminUpdateOrderStatus-infinite', AdminOrdersApiAdminUpdateOrderStatusRequest] {
    return ['adminUpdateOrderStatus-infinite', params];
}

export function useAdminUpdateOrderStatusInfiniteQuery(
    params: AdminOrdersApiAdminUpdateOrderStatusRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['adminUpdateOrderStatus-infinite', AdminOrdersApiAdminUpdateOrderStatusRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminUpdateOrderStatusInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminOrdersApi().adminUpdateOrderStatus({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
